
    import './styles.scoped.css';
    export default {
  "root": "_root_a96vq_3",
  "input": "_input_a96vq_15",
  "results": "_results_a96vq_19",
  "results-visible": "_results-visible_a96vq_25"
};
  